export default __webpack_public_path__ + "static/assets/im_normal_feedpoint.e103d005c24b54672893bedcbef56eaa.png";